import { ChildCorrectionInvoices } from '../ChildCorrectionInvoices/ChildCorrectionInvoices';

type ParentCorrectionInvoicesProps = {
    correctionId: string;
    fileName?: string;
    title?: string;
};

export const ParentCorrectionInvoices = ({
    correctionId,
    fileName,
    title,
}: ParentCorrectionInvoicesProps) => {
    return (
        <ChildCorrectionInvoices
            correctionId={correctionId}
            fileName={fileName}
            title={title}
            isParent
        />
    );
};
